var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15ZM7.49982 7.32999C8.25484 7.32999 11.9259 5.26562 11.9259 5.26562L11.9318 4.89678C11.9318 4.48958 11.6013 4.1591 11.193 4.1591H3.8066C3.39866 4.1591 3.06818 4.48958 3.06818 4.89678V5.22542C3.06818 5.22542 6.77947 7.32999 7.49982 7.32999ZM7.49982 8.34431C6.77947 8.34431 3.07408 6.37215 3.07408 6.37215L3.06818 10.0596C3.06818 10.4668 3.39903 10.7973 3.8066 10.7973H11.193C11.6013 10.7973 11.9318 10.4668 11.9318 10.0596L11.9259 6.37215C11.9259 6.37215 8.28951 8.34431 7.49982 8.34431Z","fill":"#FF007F"}));
}

Envelope.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = Envelope;

Envelope.default = Envelope;
